import React from "react";
import { ArrowUpRight } from "lucide-react";

const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 md:py-36 bg-sun-cream border-y border-sun-line relative overflow-hidden"
        >
            <div className="container-x relative">
                <div className="grid grid-cols-12 gap-6 md:gap-12">
                    <div className="col-span-12 md:col-span-5 md:sticky md:top-32 self-start">
                        <div className="overline mb-6">— Our Story</div>
                        <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em] text-sun-ink">
                            A house built
                            <br />
                            on the rule
                            <br />
                            of <span className="display-italic text-gradient">36 hours.</span>
                        </h2>
                        <a
                            href="#bulk"
                            className="mt-10 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.28em] text-sun-ink hover:text-sun-orange transition-colors group"
                            data-testid="about-export-cta"
                        >
                            Become an export partner
                            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                    </div>

                    <div className="col-span-12 md:col-span-7 space-y-8">
                        <p className="font-heading text-2xl md:text-3xl leading-snug tracking-tight text-sun-ink">
                            <span className="display-italic text-gradient">Ostrich Foods</span> began with a
                            simple obsession — that nothing should be added to a fruit, and
                            nothing should be lost from a vegetable, between the field and the
                            pouch.
                        </p>

                        <p className="font-body text-base md:text-lg text-sun-inkSoft leading-relaxed">
                            From our facility in Surat, we work directly with farmer
                            collectives across Gujarat and Maharashtra. Produce arrives at
                            sunrise and leaves as a sealed, tested powder before sundown the
                            next day. No carriers. No fillers. No anti-caking chemistry. The
                            entire catalogue is, by design, a list of one-ingredient ingredients —
                            because making your health better starts with knowing exactly what's
                            in the pouch.
                        </p>

                        <div className="grid grid-cols-2 sm:grid-cols-3 mt-12 gap-3 md:gap-4">
                            {[
                                { k: "Est. 2025", v: "born from a clean obsession" },
                                { k: "10+", v: "bulk B2B buyers" },
                                { k: "5,000+", v: "small orders shipped" },
                                { k: "24", v: "skus on the shelf" },
                                { k: "FSSAI · MSME", v: "licensed & registered" },
                                { k: "B2B + DTC", v: "ready · 2+ countries" },
                            ].map((s) => (
                                <div
                                    key={s.k}
                                    className="bg-white border border-sun-line rounded-2xl p-5 hover:border-sun-orange transition-colors group"
                                >
                                    <div className="font-heading text-3xl md:text-4xl leading-none text-sun-ink group-hover:text-sun-orange transition-colors">
                                        {s.k}
                                    </div>
                                    <div className="mt-2 overline">{s.v}</div>
                                </div>
                            ))}
                        </div>

                        {/* Parent company band */}
                        <div
                            data-testid="parent-company-raj-group"
                            className="mt-10 bg-sun-ink text-white rounded-3xl p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6 relative overflow-hidden"
                        >
                            <div className="absolute -top-20 -right-20 w-64 h-64 sun-rays opacity-10 animate-spin-slow pointer-events-none" />
                            <div className="w-24 h-24 md:w-28 md:h-28 rounded-2xl bg-white p-2 flex items-center justify-center flex-shrink-0 relative z-10">
                                <img
                                    src="/brand/raj-group.png"
                                    alt="Raj Group — parent company"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <div className="flex-1 relative z-10">
                                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-sun-goldSoft">
                                    — Part of
                                </div>
                                <div className="font-heading text-3xl md:text-4xl leading-tight tracking-[-0.01em] mt-1">
                                    The <span className="display-italic text-gradient">Raj Group</span> family
                                </div>
                                <p className="mt-2 text-sm text-white/75 leading-relaxed max-w-md">
                                    Ostrich Foods is a wellness brand by Raj Group — a registered house of trusted
                                    Indian businesses spanning food, agriculture and trade.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
